import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=f8b3b456&scoped=true&"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=f8b3b456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b3b456",
  null
  
)

export default component.exports